module.exports = __webpack_public_path__ + "media/images/product-img-06-49c8fbe422266ffc2b54f367892be797.png";